import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Icon from "../../components/ui/icon";
import "../../assets/styles/auth/verifyEmail.css";
import axios from "axios";

export default function VerifyEmail() {
    const { token } = useParams();
    const navigate = useNavigate();

    const [status, setStatus] = useState("loading");
    const API_BASE =
        window.location.origin === "http://localhost:3000"
            ? "http://localhost:5500"
            : window.location.origin;

    useEffect(() => {
        if (!token) {
            setStatus("invalid");
            return;
        }

        axios
            .post(`${API_BASE}/api/auth/verify-email`, { token })
            .then((response) => {
                if (response.data?.status) {
                    if (response.data.message === "Verification Successful") {
                        setStatus("success");
                    } else if (response.data.message === "Already Verified") {
                        setStatus("already");
                    } else {
                        setStatus("invalid");
                    }
                } else {
                    setStatus("invalid");
                }
            })
            .catch(() => {
                setStatus("invalid");
            });
    }, [token, API_BASE]);

    return (
        <main className="verification__page">
            <div className="verification__card">

                {status === "loading" && (
                    <div className="verification__loader">
                        <div className="verification__spinner" />
                        <p>Verifying your email…</p>
                    </div>
                )}

                {(status === "success" || status === "already") && (
                    <div className="verification__result">
                        <Icon
                            name="CheckCircle"
                        />
                        <h1>
                            {status === "success"
                                ? "Email Verified Successfully"
                                : "Email Already Verified"}
                        </h1>
                        <p>
                            Your account is ready. You can now log in and continue.
                        </p>
                        <button onClick={() => navigate("/auth/login")}>
                            Go to Login
                        </button>
                    </div>
                )}

                {status === "invalid" && (
                    <div className="verification__invalid">
                        <Icon name="XCircle" />
                        <h1>Invalid or Expired Link</h1>
                        <p>
                            This verification link is no longer valid.
                        </p>
                    </div>
                )}

            </div>
        </main>
    );
}